import { useState, useEffect, useCallback } from 'react';
import axios from "axios";

const chatClient = axios.create({
    baseURL: process.env.REACT_APP_BASE_URL || '/mlapi',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
});

const useChatAuthorization = ({ secretKey, scenarioId, workflowId, shortCode }) => {
    const [state, setState] = useState({ status: 'pending', authData: null });
    const [retryNonce, setRetryNonce] = useState(0);

    const retry = useCallback(() => setRetryNonce(n => n + 1), []);

    useEffect(() => {
        if (!secretKey && !shortCode) {
            setState({ status: 'error', authData: null });
            return;
        }

        setState({ status: 'pending', authData: null });

        const hasWorkflow = Boolean(scenarioId && workflowId);
        chatClient.post('/chat/authorize', {
            token: secretKey,
            shortCode: shortCode,
            scenarioId: hasWorkflow ? scenarioId : null,
            workflowId: hasWorkflow ? workflowId : null,
        })
            .then(res => setState({ status: 'authorized', authData: res.data }))
            .catch(() => setState({ status: 'error', authData: null }));

    }, [secretKey, shortCode, scenarioId, workflowId, retryNonce]);

    return { ...state, retry };
};

export default useChatAuthorization;
